import { CrewMember } from '@bechtel/types';
import { FC } from 'react';
import { Avatar, AvatarSize, Box, Icon, IconSize, Text, theme } from '@bechtel/gds';
import { useName, PersonaMessages } from '@bechtel/client-common';
import { useLingui } from '@lingui/react';
import { Trans } from '@lingui/macro';
import { WeldAddCrewStyled } from './styled';

interface WeldAssigneeProps {
  assignee?: CrewMember;
}

const WeldAssignee: FC<WeldAssigneeProps> = ({ assignee }) => {
  const { getFullName } = useName();
  const { i18n } = useLingui();
  if (assignee) {
    return (
      <Box alignItems={{ sm: 'center' }} pr={{ sm: '500' }}>
        <Avatar style={{ marginRight: `${theme.spacings[450]}` }} src={assignee?.imageUrl} size={AvatarSize.MEDIUM} />
        <Box flexDirection={{ sm: 'column' }} ml={{ sm: '300' }}>
          <Box pb={{ sm: '100' }}>
            <Text size="400" color="grey.1000">
              {getFullName(assignee?.firstName, assignee?.lastName)}
            </Text>
          </Box>
        </Box>
      </Box>
    );
  } else {
    return (
      <Box mr={{ sm: '500' }}>
        <WeldAddCrewStyled>
          <Icon size={IconSize.MEDIUM} icon="user" fillColor="blue.800" />
        </WeldAddCrewStyled>
        <Box flexDirection={{ sm: 'column' }} justifyContent={{ sm: 'center' }}>
          <Text size="400" color="grey.1000">
            <Trans>Unassigned</Trans>
          </Text>
        </Box>
      </Box>
    );
  }
};

export default WeldAssignee;
